import ConfirmSubmitProposal from './ConfirmSubmitProposal';
export default ConfirmSubmitProposal;